export default __webpack_public_path__ + "static/1.24ceedd7e27737a5f0c1cff091027c66.png";